import type {
    NotificationIndicatorBadgeMappingConstantType
} from "./type";
import type {
    IBadgeIndicatorProps
} from "../badge/type";

export const getBadgeIndicatorPropsFromNotificationIndicator = ({
    props
}: NotificationIndicatorBadgeMappingConstantType): IBadgeIndicatorProps => {
    const {
        location,
        title,
        ...badgeProps
    } = props;

    return {
        ...badgeProps,
        location: location ? {
            start: location.start ?? location.left,
            end: location.end ?? location.right,
            bottom: location.bottom,
            top: location.top
        } : undefined,
        count: title
    };
};
